import { render, staticRenderFns } from "./Accueil.vue?vue&type=template&id=3642ad6c&scoped=true&"
import script from "./Accueil.js?vue&type=script&lang=js&"
export * from "./Accueil.js?vue&type=script&lang=js&"
import style0 from "./Accueil.scoped.scss?vue&type=style&index=0&id=3642ad6c&lang=scss&scoped=true&"
import style1 from "./Accueil.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3642ad6c",
  null
  
)

export default component.exports